import { Button } from '@crowdfpl/ui-web/button';
import { Checkbox } from '@crowdfpl/ui-web/checkbox';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@crowdfpl/ui-web/dialog';
import { useLayoutEffect, useRef } from 'react';
import { buildRevoteConfirmCopy } from '@/constants/revote';
import { useRevoteConfirmModalStore } from '@/stores/revoteConfirmModal';

/** Ignore Radix close events fired by the same touch/click that opened the dialog (iOS Safari). */
const GHOST_DISMISS_GUARD_MS = 400;

export function RevoteConfirmModal() {
  const open = useRevoteConfirmModalStore(s => s.open);
  const kind = useRevoteConfirmModalStore(s => s.kind);
  const bonus = useRevoteConfirmModalStore(s => s.bonus);
  const dontShow = useRevoteConfirmModalStore(s => s.dontShow);
  const setDontShow = useRevoteConfirmModalStore(s => s.setDontShow);
  const confirm = useRevoteConfirmModalStore(s => s.confirm);
  const cancel = useRevoteConfirmModalStore(s => s.cancel);
  const openedAtRef = useRef(0);

  useLayoutEffect(() => {
    if (open) {
      openedAtRef.current = Date.now();
    }
  }, [open]);

  const copy = kind ? buildRevoteConfirmCopy(kind, bonus) : null;

  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => {
        if (nextOpen) {
          return;
        }
        if (Date.now() - openedAtRef.current < GHOST_DISMISS_GUARD_MS) {
          return;
        }
        cancel();
      }}
    >
      {copy ? (
        <DialogContent
          className="w-[calc(100vw-2rem)] rounded-2xl sm:w-full sm:max-w-[420px]"
          onOpenAutoFocus={event => {
            // Keep focus inside dialog without scrolling the page under the thumb on iOS.
            event.preventDefault();
          }}
          onPointerDownOutside={event => {
            if (Date.now() - openedAtRef.current < GHOST_DISMISS_GUARD_MS) {
              event.preventDefault();
            }
          }}
          onInteractOutside={event => {
            if (Date.now() - openedAtRef.current < GHOST_DISMISS_GUARD_MS) {
              event.preventDefault();
            }
          }}
        >
          <DialogHeader>
            <DialogTitle>{copy.title}</DialogTitle>
            <DialogDescription className="pt-1 text-[14px] leading-snug text-foreground/80">
              {copy.body}
            </DialogDescription>
          </DialogHeader>
          <label
            htmlFor="revote-dont-show-again"
            className="flex min-h-11 cursor-pointer items-center gap-2 py-1 text-[13px] text-muted-foreground"
          >
            <Checkbox
              checked={dontShow}
              onCheckedChange={value => setDontShow(value === true)}
              id="revote-dont-show-again"
            />
            <span>Don&apos;t show again</span>
          </label>
          <DialogFooter className="gap-2 sm:gap-2">
            <Button variant="ghost" onClick={cancel}>
              Cancel
            </Button>
            <Button onClick={confirm}>Change pick</Button>
          </DialogFooter>
        </DialogContent>
      ) : null}
    </Dialog>
  );
}
